export default "assets/images/spinner-13f68a1b.gif";